import React from 'react';
import { buildSmugmugUrl, buildSmugmugSrcSet } from '../utils/image';

const houses = [
  {
    label: 'Tuesday and Thursday',
    city: 'Weekday Workouts',
    copy: 'Meet at 14th and Jefferson by the Washington Monument',
    link: '7:00 AM meet-up',
    imageId: 'hp32996',
    address: 'Jefferson Dr SW & 14th St SW, Washington, DC',
  },
  {
    label: 'Saturday',
    city: 'Long Run',
    copy: 'Meet at Baked and Wired in Georgetown',
    link: '8:00 AM winter · 7:30 AM summer',
    imageId: 'vKmLbhm',
    address: 'Baked & Wired — 1052 Thomas Jefferson St NW, Washington, DC',
  },
];


export default function RunWithUs() {
  return (
    <section className="page philosophy-page">
      <header className="section-header centered serif">
        <h1 className="title">Run With Us</h1>
        <p>DM @dojoofpain on Instagram for more details</p>
        <a
          className="social-cta"
          href="https://www.instagram.com/dojoofpain/"
          target="_blank"
          rel="noreferrer"
        >
          <img src="/fist_small.png" alt="" aria-hidden="true" />
          @dojoofpain
        </a>
      </header>

      <div className="house-grid">
        {houses.map(({ label, city, copy, link, imageId, address }) => (
          <article key={city} className="house-card">
            <figure className="house-card__media">
              <img
                src={buildSmugmugUrl(imageId, 'L')}
                srcSet={buildSmugmugSrcSet(imageId)}
                sizes="(max-width: 640px) 100vw, 50vw"
                alt={`${city} meetup location`}
                loading="lazy"
                decoding="async"
              />
            </figure>
            <p className="house-card__label">{label}</p>
            <h2>{city}</h2>
            <p>{copy}</p>
            <p className="house-card__address">{address}</p>
            <p className="house-card__meta-text">{link}</p>
          </article>
        ))}
      </div>

      <div className="partners-section">
        <h2 className="partners-section__heading">Dojo Partners</h2>
        <div className="partners-section__logos">
          <a href="https://never2.com/pages/our-team-club-partners" target="_blank" rel="noopener noreferrer">
            <img src="/neversecond.png" alt="Never Second" className="partners-section__logo" />
          </a>
        </div>
      </div>

    </section>
  );
}
